import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 8l-4 4l4 4","key":"svg-0"}],["path",{"d":"M17 8l4 4l-4 4","key":"svg-1"}],["path",{"d":"M3 12l18 0","key":"svg-2"}]]

const IconArrowsHorizontal = createReactComponent('outline', 'arrows-horizontal', 'ArrowsHorizontal', __iconNode);

export default IconArrowsHorizontal;